/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './bulk-update-rest.service';
export * from './bulk-update.dto';
